import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import FeaturedEvents from "@/components/FeaturedEvents";
import Testimonials from "@/components/Testimonials";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";
import { useRef, useState } from "react";

const Index = () => {
  const featuredRef = useRef<HTMLDivElement | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const scrollToFeatured = () => {
    if (featuredRef.current) {
      featuredRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero
          onExploreClick={scrollToFeatured}
          setIsAuthenticated={setIsAuthenticated}
          isAuthenticated={isAuthenticated}
        />
        <FeaturedEvents ref={featuredRef} />
        <Features />
        <Testimonials />
        <CallToAction isAuthenticated={isAuthenticated} />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
